var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CHANNEL_MODE, CLIENT_CONTEXT, RESET, UPDATE_ANALYTICS, UPDATE_APPDATA, UPDATE_AUTHENTICATIONSTATE, UPDATE_CONFIG, UPDATE_DONTSEENUMBER, UPDATE_ERRORCONATINER, UPDATE_ERRORMESSAGE, UPDATE_FLOW, UPDATE_HASANALYTICS, UPDATE_ISAUTHENTICATE, UPDATE_ISCANCELAUTHENTICATIONENABLED, UPDATE_ISDIDNOTRECEIVECODE, UPDATE_ISDISCLOSUREVISIBLE, UPDATE_ISSENDCODEASVOICEENABLED, UPDATE_IS_LOADING, UPDATE_LANGUAGECODE, UPDATE_OPTEDOUT, UPDATE_OTPATTEMPTS, UPDATE_OTPCODEVALUE, UPDATE_PARAMS, UPDATE_PAYLOAD, UPDATE_PHONENUMBER, UPDATE_PHONESECURITYRESPONSE, UPDATE_POSSIBLETARGETS, UPDATE_REQUIREDERRORMSG, UPDATE_RETRY, UPDATE_RETRY_CONTAINER, UPDATE_SELECTEDTARGET, UPDATE_SENDOTP, UPDATE_SFFDL, UPDATE_SHOWFAILEDATTEMPTSSCREENONERROR, UPDATE_SMSCHANNEL, UPDATE_TARGETS, UPDATE_VERIFYCLICKED, UPDATE_VERIFYOTPSCREEN, UPDATE_VOICECHANNEL, UPDATE_SEND_CODE_AS, UPDATE_OTP_ACTION, RESET_OTP_ACTION } from '../constants/action-types';
var initialState = {
    payload: '',
    otpAction: null,
    isCancelAuthenticatorEnabled: false,
    isRetryAuthenticatorEnabled: true,
    isRetryHidden: false,
    isFlowInvoked: true,
    isdidNotReceiveCode: false,
    sendCode: null,
    sms: '',
    voiceCall: '',
    language_code: '',
    phone_number: '',
    possibleTargets: [],
    isDisclosureVisible: true,
    isSendAsVoiceEnabled: true,
    authenticationState: '',
    isPhoneSecurityResponse: false,
    dontSeeNumber: false,
    targets: [],
    isAuthenticate: false,
    isSendOtp: false,
    isVerifyOtpDisplayed: false,
    showErrorContainer: false,
    errorMessage: '',
    isVerifyClicked: false,
    phoneNumber: '',
    languageCode: '',
    optedOut: false,
    channels: '',
    clientContext: '',
    selectedTarget: '',
    otpAttempts: 1,
    hasAnalytics: false,
    analytics: {},
    otpCodeVerify: '',
    SFFDL: {},
    config: {},
    params: {},
    appData: {},
    requiredErrorMsg: '',
    isLoading: true
};
function rootReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case RESET_OTP_ACTION: {
            return __assign(__assign({}, state), { otpAction: initialState.otpAction });
        }
        case UPDATE_OTP_ACTION: {
            return __assign(__assign({}, state), { otpAction: action.payload });
        }
        case UPDATE_SEND_CODE_AS: {
            return __assign(__assign({}, state), { sendCode: action.payload });
        }
        case UPDATE_PAYLOAD:
            return __assign(__assign({}, state), { payload: action.payload });
        case UPDATE_RETRY:
            return __assign(__assign({}, state), { isRetryAuthenticatorEnabled: action.payload, isVerifyOtpDisplayed: false, showErrorContainer: false, errorMessage: '', otpCodeVerify: '', otpAttempts: 1, isdidNotReceiveCode: true, isLoading: true });
        case RESET:
            return initialState;
        case UPDATE_RETRY_CONTAINER:
            return __assign(__assign({}, state), { isRetryHidden: action.payload });
        case CLIENT_CONTEXT:
            return __assign(__assign({}, state), { clientContext: action.payload });
        case UPDATE_OTPCODEVALUE:
            return __assign(__assign({}, state), { otpCodeVerify: action.payload });
        case UPDATE_FLOW:
            return __assign(__assign({}, state), { isFlowInvoked: action.payload });
        case UPDATE_LANGUAGECODE:
            return __assign(__assign({}, state), { language_code: action.payload });
        case UPDATE_SMSCHANNEL:
            return __assign(__assign({}, state), { sms: action.payload });
        case UPDATE_VOICECHANNEL:
            return __assign(__assign({}, state), { voiceCall: action.payload });
        case UPDATE_ISDIDNOTRECEIVECODE:
            return __assign(__assign({}, state), { isdidNotReceiveCode: action.payload });
        case UPDATE_PHONENUMBER:
            return __assign(__assign({}, state), { phone_number: action.payload });
        case UPDATE_POSSIBLETARGETS:
            return __assign(__assign({}, state), { possibleTargets: action.possibleTargets });
        case UPDATE_ISDISCLOSUREVISIBLE:
            return __assign(__assign({}, state), { isDisclosureVisible: action.payload });
        case UPDATE_ISCANCELAUTHENTICATIONENABLED:
            return __assign(__assign({}, state), { isCancelAuthenticationEnabled: action.payload });
        case UPDATE_ISSENDCODEASVOICEENABLED:
            return __assign(__assign({}, state), { isSendAsVoiceEnabled: action.payload });
        case UPDATE_SHOWFAILEDATTEMPTSSCREENONERROR:
            return __assign(__assign({}, state), { showFailedAttemptsScreenOnError: action.payload });
        case UPDATE_AUTHENTICATIONSTATE:
            return __assign(__assign({}, state), { authenticationState: action.payload });
        case UPDATE_PHONESECURITYRESPONSE:
            return __assign(__assign({}, state), { isPhoneSecurityResponse: action.payload });
        case UPDATE_DONTSEENUMBER:
            return __assign(__assign({}, state), { dontSeeNumber: action.payload });
        case UPDATE_TARGETS:
            return __assign(__assign({}, state), { targets: action.payload });
        case UPDATE_ISAUTHENTICATE:
            return __assign(__assign({}, state), { isAuthenticate: action.payload });
        case UPDATE_SENDOTP:
            return __assign(__assign({}, state), { isSendOtp: action.payload });
        case UPDATE_VERIFYOTPSCREEN:
            return __assign(__assign({}, state), { isVerifyOtpDisplayed: action.payload });
        case UPDATE_ERRORCONATINER:
            return __assign(__assign({}, state), { showErrorContainer: action.payload });
        case UPDATE_ERRORMESSAGE:
            return __assign(__assign({}, state), { errorMessage: action.payload });
        case UPDATE_VERIFYCLICKED:
            return __assign(__assign({}, state), { isVerifyClicked: action.payload });
        case UPDATE_OPTEDOUT:
            return __assign(__assign({}, state), { optedOut: action.payload });
        case CHANNEL_MODE:
            return __assign(__assign({}, state), { channels: action.payload });
        case UPDATE_SELECTEDTARGET:
            return __assign(__assign({}, state), { selectedTarget: action.payload });
        case UPDATE_OTPATTEMPTS:
            return __assign(__assign({}, state), { otpAttempts: action.payload });
        case UPDATE_HASANALYTICS:
            return __assign(__assign({}, state), { hasAnalytics: action.payload });
        case UPDATE_ANALYTICS:
            return __assign(__assign({}, state), { analytics: action.payload });
        case UPDATE_SFFDL:
            return __assign(__assign({}, state), { SFFDL: action.payload });
        case UPDATE_CONFIG:
            return __assign(__assign({}, state), { config: action.payload });
        case UPDATE_PARAMS:
            return __assign(__assign({}, state), { params: action.payload });
        case UPDATE_APPDATA:
            return __assign(__assign({}, state), { appData: action.payload });
        case UPDATE_REQUIREDERRORMSG:
            return __assign(__assign({}, state), { requiredErrorMsg: action.payload });
        case UPDATE_IS_LOADING:
            return __assign(__assign({}, state), { isLoading: action.payload });
        default:
            return state;
    }
}
export default rootReducer;
